import axios from "axios";
import { getApiAsyn, baseUrl, getApiAsynarrayBuffer } from "../../PostAPI";
import { handleAPIError, APIError } from "../../common/errorHandler";
import { API_URL } from "../../../utils/constant";
import { extractData } from "../../../utils";
import { getDecoratedUrl, decorateWithPaginationParamsPost, decorateWithSortParamsPost } from "../../common/urlService";
import { formatDate, DATE_STRATEGY } from "../../../utils/date";

const { post } = axios;

export const fetchAffiliate = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.AFFILIATE.GET,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

const dataUploadApi = (url, data, isEdit = false) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: localStorage.getItem("token"),
    },
  };

  return post(baseUrl + url, data, config);
};

export const createAffiliate = async (payload) => {
  try {
    let result = await dataUploadApi(`${API_URL.AFFILIATE.CREATE}`, payload);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const editAffiliate = async (payload) => {
  const url = API_URL.AFFILIATE.EDIT;

  try {
    let result = await dataUploadApi(url, payload.data, true);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const exportAffiliateRecord = async (payload) => {
  const userId = localStorage.getItem("userId");
  const url = `${API_URL.AFFILIATE.EXPORT}?userId=${userId}`;
  try {
    let result = await getApiAsynarrayBuffer(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAffiliateById = async (payload) => {
  const url = API_URL.AFFILIATE.GET_BY_ID.replace(":id", payload?.id);
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    result = extractData(result, !payload?.filters);

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAffiliateDropdown = async (payload) => {
  const url = API_URL.AFFILIATE.DROPDOWN;
  try {
    let result = await getApiAsyn(
      url + "?userId=" + localStorage.getItem("userId"),
      localStorage.getItem("token")
    );

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAffiliateReport = async (payload) => {
  const url = API_URL.AFFILIATE.REPORT;
  
  try {
    let pageno = decorateWithPaginationParamsPost(payload);
    let sortdata = decorateWithSortParamsPost(payload);
    if (sortdata === "") {
      sortdata = "id,desc";
    }
    
    const columnFilters = payload?.filters || [];
    const getFilterValue = (filterKey) => {
      const filter = columnFilters.find(f => f.filterField === filterKey);
      return filter?.query || null;
    };
    
    const requestPayload = {
      pageNumber: pageno?.pageNumber,
      pageSize: pageno?.pageSize,
      paged: true,
      sort: sortdata,
      startDate: payload?.additinalFilter?.startDate || payload?.startDate,
      endDate: payload?.additinalFilter?.endDate || payload?.endDate,
      locationId: payload?.additinalFilter?.locationId || payload?.locationId || [],
      networkId: payload?.additinalFilter?.networkId || payload?.networkId || [],
      affiliateId: payload?.additinalFilter?.affiliateId || payload?.affiliateId || [],
      status: payload?.additinalFilter?.status ?? payload?.status ?? null,
      type: payload?.additinalFilter?.type || payload?.type || null,
      filterRef: getFilterValue("ref"),
      filterAffiliateName: getFilterValue("affiliateName"),
      filterCommissionAmount: getFilterValue("commissionAmount"),
      filterLocationName: getFilterValue("locationName"),
      filterNetworkName: getFilterValue("networkName"),
      filterRenterName: getFilterValue("renterName"),
      filterRenterEmail: getFilterValue("renterEmail"),
      filterPickupDate: getFilterValue("pickupDate"),
      filterPickupTime: getFilterValue("pickupTime"),
      filterDropoffDate: getFilterValue("dropoffDate"),
      filterDropoffTime: getFilterValue("dropoffTime"),
      filterTotalAmount: getFilterValue("totalAmount"),
      filterReservationStatus: getFilterValue("reservationStatus"),
      filterCreatedTime: getFilterValue("createdTime"),
    };

    let result = await dataUploadApi(url, requestPayload);

    if (result?.error) {
      throw new APIError(result);
    }

    return result?.data || result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const exportAffiliateReport = async (payload) => {
  const url = API_URL.AFFILIATE.EXPORT_REPORT;
  try {
    const requestPayload = {
      startDate: payload?.startDate,
      endDate: payload?.endDate,
      locationId: payload?.locationId || [],
      networkId: payload?.networkId || [],
      affiliateId: payload?.affiliateId || [],
      status: payload?.status ?? null,
      type: payload?.type || null,
    };

    let result = await getApiAsynarrayBuffer(
      `${url}?${new URLSearchParams({
        startDate: requestPayload.startDate || '',
        endDate: requestPayload.endDate || '',
      }).toString()}`,
      localStorage.getItem("token")
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const downloadAffiliateReport = async (payload) => {
  const url = API_URL.AFFILIATE.DOWNLOAD_REPORT;
  try {
    const requestPayload = {
      startDate: payload?.startDate,
      endDate: payload?.endDate,
      locationId: payload?.locationId || [],
      networkId: payload?.networkId || [],
      affiliateId: payload?.affiliateId || [],
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
        authorization: localStorage.getItem("token"),
      },
      responseType: "arraybuffer",
    };

    let result = await axios.post(baseUrl + url, requestPayload, config);

    if (result?.error) {
      throw new APIError(result);
    }
    return result?.data || result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const emailAffiliateReport = async (payload) => {
  const url = API_URL.AFFILIATE.EMAIL_REPORT;
  try {
    const requestPayload = {
      startDate: payload?.startDate,
      endDate: payload?.endDate,
      locationId: payload?.locationId || [],
      networkId: payload?.networkId || [],
      affiliateId: payload?.affiliateId || [],
      recipientEmails: payload?.recipientEmails || [],
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: localStorage.getItem("token"),
      },
    };

    let result = await axios.post(baseUrl + url, requestPayload, config);

    if (result?.error) {
      throw new APIError(result);
    }
    return result?.data || result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAffiliateLocationDropdown = async (affiliateId) => {
  const url = `${API_URL.AFFILIATE.LOCATION_DROPDOWN}?affiliateId=${affiliateId}`;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAffiliateNetworkDropdown = async (affiliateId) => {
  const url = `${API_URL.AFFILIATE.NETWORK_DROPDOWN}?affiliateId=${affiliateId}`;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAffiliateDashboard = async (payload = {}) => {
  let url = API_URL.AFFILIATE.DASHBOARD;
  const params = [];
  
  if (payload.locationId && payload.locationId.length > 0) {
    params.push(`locationId=${payload.locationId.join(',')}`);
  }
  if (payload.affiliateId && payload.affiliateId.length > 0) {
    params.push(`affiliateId=${payload.affiliateId.join(',')}`);
  }
  if (payload.period) {
    params.push(`period=${payload.period}`);
  }
  if (payload.limit !== undefined) {
    params.push(`limit=${payload.limit}`);
  }
  
  if (params.length > 0) {
    url += '?' + params.join('&');
  }
  
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAffiliateDashboardData = async (payload = {}) => {
  const pageSize = payload.pageSize || 10;
  const pageNumber = payload.pageNumber !== undefined ? payload.pageNumber + 1 : 1;
  const period = payload.period || 30;
  const url = `${API_URL.AFFILIATE.DASHBOARD_DATA}?period=${period}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAffiliateReservations = async (payload = {}) => {
  const { affiliateId, pageNumber = 1, pageSize = 5 } = payload;
  
  if (!affiliateId) {
    console.error("affiliateId is required");
    return handleAPIError(new Error("affiliateId is required"));
  }
  
  const period = payload.period || 30;
  const url = `${API_URL.AFFILIATE.AFFILIATE_RESERVATIONS}?period=${period}&affiliateId=${affiliateId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
  
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchLocationWithAffiliateDropdown = async (affiliateId = null) => {
  const userId = localStorage.getItem("userId");
  let url = affiliateId 
    ? `${API_URL.AFFILIATE.LOCATION_WITH_AFFILIATE_DROPDOWN}?affiliateId=${affiliateId}&userId=${userId}`
    : `${API_URL.AFFILIATE.LOCATION_WITH_AFFILIATE_DROPDOWN}?userId=${userId}`;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    if (Array.isArray(result)) {
      return result.filter((item) => item.hasAffiliate === false);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchCurrencyCodeDropdown = async () => {
  const userId = localStorage.getItem("userId");
  const url = `${API_URL.AFFILIATE.CURRENCY_CODE_DROPDOWN}?userId=${userId}`;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAffiliateDependentLocationsDropdown = async (affiliateIds) => {
  const url = `${API_URL.AFFILIATE.AFFILIATE_LOCATIONS_DROPDOWN}?affiliateIds=${affiliateIds}`;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAffiliateDependentNetworksDropdown = async (affiliateIds) => {
  const url = `${API_URL.AFFILIATE.AFFILIATE_NETWORKS_DROPDOWN}?affiliateIds=${affiliateIds}`;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAffiliateInvoice = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.AFFILIATE.INVOICE.GET,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const generateAffiliateInvoice = async (payload) => {
  const url = API_URL.AFFILIATE.INVOICE.GENERATE;
  try {
    const requestPayload = {
      affiliateId: payload?.affiliateId || [],
      startDate: payload?.startDate,
      endDate: payload?.endDate,
      dueDate: payload?.dueDate,
      status: payload?.status ?? null,
      type: payload?.type || null,
      userId: payload?.userId || localStorage.getItem("userId"),
    };

    let result = await axios.post(baseUrl + url, requestPayload, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: localStorage.getItem("token"),
      },
    });

    if (result?.error) {
      throw new APIError(result);
    }
    return result?.data || result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const downloadAffiliateInvoicePdf = async (invoiceId) => {
  const url = `${API_URL.AFFILIATE.INVOICE.DOWNLOAD}?invoiceIds=${invoiceId}`;
  try {
    let result = await getApiAsynarrayBuffer(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const updateAffiliateInvoiceStatus = async (invoiceId, status, extraData = {}) => {
  const userId = localStorage.getItem("userId");
  const url = API_URL.AFFILIATE.INVOICE.UPDATE_STATUS;

  const rawAmount = extraData?.totalCommissionAmount;
  const parsedAmount =
    rawAmount !== undefined && rawAmount !== null && rawAmount !== ""
      ? parseFloat(String(rawAmount).replace(/[^0-9.-]/g, ""))
      : undefined;

  const rawDueDate = extraData?.dueDate;
  const formattedDueDate = rawDueDate
    ? formatDate(rawDueDate, DATE_STRATEGY.DATE_ISO)
    : undefined;

  const requestPayload = {
    invoiceId: Number(invoiceId),
    invoiceStatus: status,
    userId: Number(userId),
    ...(parsedAmount !== undefined && !isNaN(parsedAmount) && { totalCommissionAmount: parsedAmount }),
    ...(formattedDueDate && { dueDate: formattedDueDate }),
  };

  try {
    let result = await post(baseUrl + url, requestPayload, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: localStorage.getItem("token"),
      },
    });

    if (result?.error) {
      throw new APIError(result);
    }
    return result?.data || result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAffiliateInvoicePayments = async (payload = {}) => {
  const { invoiceId, page = 1, size = 10 } = payload;
  
  if (!invoiceId) {
    console.error("invoiceId is required");
    return handleAPIError(new Error("invoiceId is required"));
  }
  
  const url = `${API_URL.AFFILIATE.INVOICE.GET_PAYMENTS}?invoiceId=${invoiceId}&paged=true&page=${page}&size=${size}`;
  
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const updateAffiliatePayment = async (payload) => {
  const url = API_URL.AFFILIATE.INVOICE.UPDATE_PAYMENT;
  try {
    const requestPayload = {
      paymentId: payload.paymentId,
      userId: parseInt(localStorage.getItem("userId")),
      ...(payload.paidAmount !== undefined && payload.paidAmount !== null && {
        paidAmount: parseFloat(payload.paidAmount),
      }),
      ...(payload.paymentDate && {
        paymentDate: formatDate(payload.paymentDate, DATE_STRATEGY.DATE_ISO),
      }),
      ...(payload.paymentMethod && { paymentMethod: payload.paymentMethod }),
      ...(payload.paymentStatus && { paymentStatus: payload.paymentStatus }),
      ...(payload.reason !== undefined && { reason: payload.reason }),
      ...(payload.additionalInfo !== undefined && { additionalInfo: payload.additionalInfo }),
    };

    let result = await post(baseUrl + url, requestPayload, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: localStorage.getItem("token"),
      },
    });

    if (result?.error) {
      throw new APIError(result);
    }
    return result?.data || result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const recordAffiliatePayment = async (payload) => {
  const url = API_URL.AFFILIATE.INVOICE.RECORD_PAYMENT;
  try {
    let result = await post(baseUrl + url, payload, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: localStorage.getItem("token"),
      },
    });

    if (result?.error) {
      throw new APIError(result);
    }
    return result?.data || result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const getAffiliateInvoiceDetail = async (invoiceId) => {
  const url = `${API_URL.AFFILIATE.INVOICE.GET_DETAIL}?invoiceId=${invoiceId}`;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
